module.exports = __webpack_public_path__ + "static/media/kavak-heart-percent.71274f1b.svg";